<template>
  <div class="hello">
    <header>
      <div class="logo"><img :src="data.appIconUrl" alt="" /></div>
      <p class="name">{{ data.appName }}</p>
      <p class="title">{{ data.versionDesc }}</p>
      <p class="size">{{ data.apkSize }}</p>
      <p class="btn" @click="downLoad">立即安装</p>
    </header>
    <div class="banner_box">
      <div class="banner">
        <div v-for="(item, i) in data.previewUrl" :key="i">
          <img :src="item" alt="" />
        </div>
      </div>
    </div>
    <div class="content">
      <h2>应用介绍</h2>
      <p>　{{ data.applicationRecommend }}</p>
    </div>
    <div class="content">
      <h2>更新说明</h2>
      <p>{{ data.versionDesc }}</p>
    </div>
    <!-- <div class="content">
      <h2>其他信息</h2>
      <p>{{data.versionDesc}}
      </p>
    </div> -->
    <div class="copy">
      <h2>发布人</h2>
      <p>{{ data.appRelease }}</p>
    </div>
    <div class="download" @click="downLoad">立即安装</div>
    <div class="left_quan"></div>
    <div class="right_quan"></div>
  </div>
</template>

<script>
import { app_get_id } from "@/api/tool_app";
export default {
  name: "downLoad",
  data() {
    return {
      id: "",
      data: {},
    };
  },
  mounted() {
    let that = this;
    let data = {
      id: this.$route.query.id,
    };
    app_get_id(data)
      .then((res) => {
        if (res.code === 1) {
          that.data = res.data;
          document.getElementsByClassName("banner")[0].style.width = ((that.data.previewUrl.length * 2.78) +0.8).toFixed(2) + "rem";
        }
      })
      .catch((error) => {});
    // this.id = "2502650149935776765";
    // this.id = this.query.id;
    // this.$axios.defaults.baseURL = VUE_APP_API;
    // this.$axios.defaults.baseURL = "http://192.168.0.13:9096/";
    // const url = "app/" + this.id;
    // this.$axios.get(url).then(function (res) {
    //   if (res.data.code === 1) {
    //     that.data = res.data.data;
    //     console.log(that.data);
    //     document.getElementsByClassName("banner")[0].style.width =
    //       (that.data.previewUrl.length * 2.78).toFixed(2) + "rem";
    //     console.log((that.data.previewUrl.length * 2.78).toFixed(2) + "rem");
    //   }
    // });
    this.remCompute(750, 1024);
  },
  methods: {
    remCompute(designWidth, maxWidth) {
      var doc = document,
        win = window,
        docEl = doc.documentElement,
        remStyle = document.createElement("style"),
        tid;

      function refreshRem() {
        var width = docEl.getBoundingClientRect().width;
        maxWidth = maxWidth || 540;
        width > maxWidth && (width = maxWidth);
        var rem = (width * 100) / designWidth;
        remStyle.innerHTML = "html{font-size:" + rem + "px;}";
      }

      if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(remStyle);
      } else {
        var wrap = doc.createElement("div");
        wrap.appendChild(remStyle);
        doc.write(wrap.innerHTML);
        wrap = null;
      }
      //要等 wiewport 设置好后才能执行 refreshRem，不然 refreshRem 会执行2次；
      refreshRem();

      win.addEventListener(
        "resize",
        function () {
          clearTimeout(tid); //防止执行两次
          tid = setTimeout(refreshRem, 300);
        },
        false
      );

      win.addEventListener(
        "pageshow",
        function (e) {
          if (e.persisted) {
            // 浏览器后退的时候重新计算
            clearTimeout(tid);
            tid = setTimeout(refreshRem, 300);
          }
        },
        false
      );

      if (doc.readyState === "complete") {
        doc.body.style.fontSize = "16px";
      } else {
        doc.addEventListener(
          "DOMContentLoaded",
          function (e) {
            doc.body.style.fontSize = "16px";
          },
          false
        );
      }
    },
    downLoad() {
      window.open(this.data.apkUrl, "_self");
    },
  },
};
</script>

sty
<style>
body{
  margin:0;
  padding:0;
}
p {
  padding: 0;
  margin: 0;
  font-weight: 500;
  overflow-y:hidden;
}
::-webkit-scrollbar {
  display:none!important;
 }

.hello{
  background-color: #fff;
}

header {
  width: 7.5rem;
  height: 6.2rem;
  font-size: 1rem;
  font-size: 0.34rem;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("../../assets/downLoad/bc.png") no-repeat;
  background-size: 100%;
}

header .logo {
  width: 1.46rem;
  height: 1.46rem;
  margin-top: 1.34rem;
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
}
header .logo img {
  width: 100%;
  height: 100%;
}

header .name {
  font-size: 0.34rem;
  color: #333;
  font-weight: bold;
  margin: 0.36rem 0 0.2rem 0;
}

header .title {
  font-size: 0.24rem;
  color: #999;
  margin-bottom: 0.31rem;
  font-weight: 500;
}

header .size {
  font-size: 0.24rem;
  color: #2479ed;
  margin-bottom: 0.44rem;
  font-weight: 500;
}

header .btn {
  width: 1.8rem;
  height: 0.56rem;
  background-color: #2479ed;
  color: #fff;
  border-radius: 14px;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.56rem;
}

.banner_box {
  width: 7.5rem;
  height: 4.54rem;
  overflow: hidden;
  margin-top: 0.56rem;
  overflow-x: scroll;
}

.banner_box::-webkit-scrollbar {
  display: none;
}

.banner {
  /* width: 13.9rem; */
  height: 4.54rem;
  padding: 0 0.4rem;
}

.banner div {
  height: 4.54rem;
  width: 2.54rem;
  background-color: #fff;
  margin: 0 0.12rem;
  float: left;
  border-radius: 6px;
  overflow: hidden;
}

.banner div img {
  width: 100%;
  height: 100%;
}

.content {
  margin-top: 1.23rem !important;
  width: 6.71rem;
  margin: 0 auto;
}

.content h2 {
  color: #2479ed;
  font-size: 0.34rem;
  font-weight: bold;
}

.content p {
  color: #999999;
  font-size: 0.24rem;
  line-height: 0.5rem;
  text-align: left;
}

.copy {
  width: 6.12rem;
  height: 0.81rem;
  background-color: #e5e5e5;
  border-radius: 10px;
  margin: 0.5rem auto;
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
  margin-bottom: 1.5rem;
}

.copy h2 {
  font-size: 0.3rem;
  font-weight: bold;
}

.copy p {
  font-size: 0.24rem;
}

.left_quan {
  position: absolute;
  top: 5.5rem;
  left: 0;
  width: 1.7rem;
  height: 2.7rem;
  background: url("../../assets/downLoad/yuan.png") no-repeat;
  background-position-x: 100%;
  background-size: 200%;
  z-index: -1;
}

.right_quan {
  position: absolute;
  top: 8.5rem;
  right: 0;
  width: 3.25rem;
  height: 5.86rem;
  background: url("../../assets/downLoad/yuan.png") no-repeat;
  background-position-x: 0%;
  background-size: 180%;
  z-index: -1;
}

.download {
  position: fixed;
  bottom: 0.5rem;
  width: 5.7rem;
  height: 0.78rem;
  background-color: #2479ed;
  border-radius: 20px;
  left: 0.9rem;
  color: #fefefe;
  font-size: 0.3rem;
  text-align: center;
  line-height: 0.78rem;
}
</style>
